import { COLOR } from '../../../constants/styles';
export const SHADOW_STYLE = {
  shadowOpacity: 0.1,
  shadowRadius: 8,
  shadowColor: COLOR.text,
  shadowOffset: { height: 2, width: 0 },
  elevation: 2,
  borderColor: '#eeeeee',
  borderWidth: 1,
};
